<template>
	<div class="content-row">
		<div v-for="(c, index) in content">
			<component v-for="(block, i) in c.content" :is="block.template" v-bind="block" :key="'block-' + c + '-' + i"></component>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['id', 'template', 'content'],
		mounted() {
			console.log(this.content);
		}
	}
</script>